// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"47379c4f","651":"ab28d819","703":"75140878","759":"a25761b0","787":"c7af59e1"}[chunkId] + ".chunk.js";
};